import React from 'react';
import _ from 'lodash';
import {
  makeStyles,
  Box, TablePagination
} from '@material-ui/core';

import Card from 'src/components/Card';
import EmptyState from 'src/components/EmptyState';
import Activity from './Activity';
import HttpLedger from '../../../components/HttpLedger';
import Loader from '../../../components/Loader';


const useStyles = makeStyles((theme) => ({
  group: {
    '& + &': {
      marginTop: theme.spacing(4)
    }
  },
  activity: {
    position: 'relative',
    '& + &': {
      marginTop: theme.spacing(3),
      '&:before': {
        position: 'absolute',
        content: '" "',
        height: 20,
        width: 1,
        top: -20,
        left: 20,
        backgroundColor: theme.palette.divider
      }
    }
  }
}));

interface Props {
  url: string,
  title: string,
  includeEngagementName?: boolean,
}

const Activities = ({
  url,
  includeEngagementName,
  title,
}: Props) => {
  const classes = useStyles();

  return (
    <Card title={title}>
      <HttpLedger
        url={url}
        emptyState={<EmptyState />}
        isPaginated
        defaultOrdering="-created_datetime"
        defaultPageSize={8}
        render={({
          results: events,
          handlePageChange,
          page,
          limit,
          rawResults,
          isLoading,
        }: any) => (
          <Box display="flex" flexDirection="column" flex="1 1">
            {
              isLoading ? (
                <Loader />
              ) : !_.isEmpty(events) ? events.map((event: any) => (
                <Activity
                  className={classes.activity}
                  event={event}
                  includeEngagementName={includeEngagementName}
                />
              )) : <EmptyState />
            }
            <TablePagination
              component="div"
              count={rawResults.count}
              onChangePage={handlePageChange}
              rowsPerPage={limit}
              rowsPerPageOptions={[]}
              page={page - 1}
            />
          </Box>
        )}
      />
    </Card>
  );
};

export default Activities;
